
<nav aria-label="Main">
  <ul>
    @for (item of visibleItems(); track item.route()) {
      <li routerLinkActive="active" #rla="routerLinkActive">
        <i class="fad {{item.icon}} nav-icon-collapsed" aria-hidden="true"></i>
        <div class="nav-flyout no-children">
          <a class="primary-link" [routerLink]="item.route()" [attr.aria-current]="rla.isActive ? 'page' : null">
            <i class="fad {{item.icon}} nav-icon-collapsed" aria-hidden="true"></i>
            {{item.label}}
          </a>
        </div>
      </li>
    }
  </ul>
</nav>
